import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import "./Header.less";
import { setHashParam, parseQueryString } from "../../../lib";

// Constants for better maintainability
const TABS = [
    { key: "patients", label: "Patients" },
    { key: "diagnosis", label: "Diagnosis" },
    { key: "allergy", label: "Allergy" },
    { key: "leads", label: "Leads" }
];

const ViewHeader = ({
    settings,
    location,
    urlParams,
    activeTab,
    onTabChange
}) => {
    // Handle tab change
    const handleTabChange = useCallback((tabName) => {
        onTabChange(tabName);
        setHashParam("_resource", tabName);
    }, [onTabChange]);

    return (
        <div className="tab-content view-header">
            {/* Tab Navigation */}
            <nav className="tab-navigation">
                <ul className="nav-tabs">
                    {TABS.map((tab) => (
                        <li
                            key={tab.key}
                            className={`nav-tab ${activeTab === tab.key ? "active" : ""}`}
                        >
                            <button
                                className={`btn  ${activeTab === tab.key ? "btn-primary" : "btn-muted"}`}
                                onClick={() => handleTabChange(tab.key)}
                            >
                                {tab.label}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};

ViewHeader.propTypes = {
    settings: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    urlParams: PropTypes.object.isRequired,
    activeTab: PropTypes.string.isRequired,
    onTabChange: PropTypes.func.isRequired,
};

export default React.memo(ViewHeader);